<template>
  <v-row justify="center">
    <v-col
      cols="12"
      :md="!view?12:8"
    >
      <base-material-card icon="mdi-cash-register">
        <template v-slot:after-heading>
          <div class="text-h6 font-weight-light">
            <span class="text-body-1">Заказ</span>
            <v-spacer />
            <span class="text-body-2">{{ title }}
              <v-icon
                v-if="view && form.id!=null && ($store.state.access[19][3] || $store.state.access[19][4] && form.creator && form.creator.id == $store.state.user.id)"
                @click="$emit('change', form.id)"
              >mdi-pencil</v-icon>
              <v-icon
                v-if="change && form.id!=null"
                @click="$emit('view', form.id)"
              >mdi-eye</v-icon>
            </span>
          </div>
        </template>
        <base-material-tabs color="warning">
          <v-tab
            v-for="(tab, i) in tabs"
            :key="i"
          >
            {{ tab }}
          </v-tab>
          <v-tab-item>
            <v-row>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.created"
                  label="Дата создания"
                  type="date"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-text-field
                  v-model="form.number"
                  label="Системный номер"
                  :disabled="true"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-select
                  v-model="form.state"
                  label="Статус"
                  :items="select.state"
                  :readonly="true"
                />
              </v-col>
              <v-col cols="12">
                <v-autocomplete
                  v-if="$store.state.access[19][5]"
                  v-model="form.client"
                  clearable
                  :filter="client_filter"
                  :items="select.clients"
                  item-value="id"
                  label="Наименование клиента"
                  :disabled="view"
                  :loading="search.client.loading"
                  :search-input.sync="search.client.text"
                  hide-no-data
                  hint="Введите минимум три символа для поиска"
                >
                  <template v-slot:selection="{item}">
                    <v-list>
                      <v-list-item-content>
                        <v-list-item-title> {{ item.legal.name.short }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list two-line>
                      <v-list-item-content>
                        <v-list-item-title>  {{ item.legal.name.short }}</v-list-item-title>
                        <v-list-item-subtitle>ИНН: {{ item.legal.inn }} КПП: {{ item.legal.kpp }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col
                cols="12"
                md="5"
              >
                <v-autocomplete
                  v-model="selected.item"
                  :filter="item_filter"
                  return-object
                  :items="select.item"
                  label="Поиск товаров и услуг"
                  :disabled="view || !form.client"
                  :loading="search.item.loading"
                  :search-input.sync="search.item.text"
                  hide-no-data
                  hint="Введите минимум три символа для поиска"
                >
                  <template v-slot:selection="{item}">
                    <v-list>
                      <v-list-item-content>
                        <span v-if="item">
                          {{ item.name }}
                        </span>
                      </v-list-item-content>
                    </v-list>
                  </template>
                  <template v-slot:item="{item}">
                    <v-list two-line>
                      <v-list-item-content>
                        <span v-if="item">
                          {{ item.name }}
                        </span>
                      </v-list-item-content>
                    </v-list>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="4"
              >
                <v-btn
                  color="primary"
                  :disabled="!selected.item"
                  @click="item_selected()"
                >
                  <span class="mx-10">Добавить</span>
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-data-table
                  :items="form.items"
                  :headers="[
                    {
                      text: 'Номер',
                      value: 'number',
                    },
                    {
                      text: 'Тип',
                      value: 'type',
                    },
                    {
                      text: 'Наименование',
                      value: 'name',
                    },
                    {
                      text: 'Стоимость',
                      value: 'price',
                    },
                    {
                      text: 'Количество',
                      value: 'count',
                    },
                    {
                      text: 'Сумма',
                      value: 'amount',
                    },
                    {
                      text: 'Действие',
                      value: 'delete'
                    }
                  ]"
                  :footer-props="datatable_footer"
                  no-data-text="Нет данных для отображения"
                  @click:row="(a) => {selected.current_item = a, selected.change_settings = false}"
                >
                  <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
                    {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
                  </template>
                  <template v-slot:item.type="{ item }">
                    <span v-if="item && item.type">
                      {{ dict.type[item.type] }}
                    </span>
                  </template>
                  <template v-slot:item.delete="{ item }">
                    <v-icon @click="change_item(item)">
                      mdi-pencil
                    </v-icon>
                    <v-icon @click="delete_item(item)">
                      mdi-delete
                    </v-icon>
                  </template>
                  <template v-slot:item.price="{item}">
                    <v-text-field
                      v-model="item.price"
                      type="number"
                      @input="item.amount = item.price * item.count"
                    />
                  </template>
                  <template v-slot:item.count="{item}">
                    <v-text-field
                      v-model="item.count"
                      type="number"
                      @input="item.amount = item.price * item.count"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-data-table
                  v-if="selected.current_item"
                  :items="selected.current_item.settings"
                  :headers="[
                    {value: 'description', text: 'Описание', width: 300},
                    {value: 'value', text: 'Значение', width: 150},
                  ]"
                  no-data-text="Нет данных для отображения"
                >
                  <template v-slot:item.description="{item}">
                    <v-text-field
                      v-model="item.description"
                      readonly
                    />
                  </template>

                  <template v-slot:item.value="{item}">
                    <v-text-field
                      v-if="item.type == 0"
                      v-model="selected.current_item.attributes[item.key]"
                    />
                    <v-checkbox
                      v-if="item.type == 1"
                      v-model="selected.current_item.attributes[item.key]"
                    />
                    <v-select
                      v-if="item.type == 2"
                      v-model="selected.current_item.attributes[item.key]"
                      :items="item.values"
                    />
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
        </base-material-tabs>
        <v-row>
          <v-col
            cols="12"
          >
            <v-btn
              v-if="change"
              color="primary"
              large
              min-width="100"
              class="mr-5"
              @click="save_order"
            >
              Сохранить
            </v-btn>
            <v-btn
              v-if="create"
              color="primary"
              large
              min-width="100"
              class="mr-5"
              @click="create_order"
            >
              Создать
            </v-btn>
            <v-btn
              color="secondary"
              large
              min-width="100"
              @click="$router.go(-1)"
            >
              Назад
            </v-btn>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>

    <v-col
      v-if="view"
      cols="12"
      md="4"
    >
      <base-material-tabs color="warning">
        <v-tab v-if="$store.state.access[3][1] || $store.state.access[3][2]">
          События
        </v-tab>
        <v-tab v-if="$store.state.access[5][1] || $store.state.access[5][2]">
          Изменения
        </v-tab>
        <v-tab-item v-if="$store.state.access[3][1] || $store.state.access[3][2]">
          <base-material-card
            class="v-card-profile"
            title="События"
          >
            <v-card-text>
              <v-list-item
                v-for="(item,index) in events"
                :key="index"
                two-line
              >
                <v-list-item-content>
                  <v-list-item-title v-if="item.type>0 && $store.state.dict.events[item.type]">
                    {{ $store.state.dict.events[item.type].name }} {{ item.start }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span v-if="item.user">{{ item.user_item.surname }} {{ item.user_item.name }} {{ item.user_item.patronymic }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle>
                    {{ item.theme }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon
                    large
                    @click="showEvent(item)"
                  >
                    mdi-eye
                  </v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                min-width="100"
                @click="showCreateEvent"
              >
                Создать
              </v-btn>
            </v-card-actions>
          </base-material-card>
        </v-tab-item>
        <v-tab-item v-if="$store.state.access[5][1] || $store.state.access[5][2]">
          <base-material-card
            class="v-card-profile"
            title="История изменений"
          >
            <v-card-text>
              <v-list-group
                v-for="(log,index) in logs"
                :key="index"
              >
                <v-list-item
                  slot="activator"
                  two-line
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $store.state.dict.log[log.type] }}
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="log.user">
                      {{ log.user.surname }} {{ log.user.name }} {{ log.user.patronymic }}
                    </v-list-item-subtitle>
                    <v-list-item-subtitle>
                      {{ log.date_text }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-card>
                  <v-row
                    align="center"
                    justify="center"
                  >
                    <pre class="ma-5"><code class="json">{{ log.diff }}</code></pre>
                  </v-row>
                </v-card>
              </v-list-group>
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="success"
                width="150"
                @click="$router.push('/admin/log/list?entity=' + form.id)"
              >
                Показать все
              </v-btn>
            </v-card-actions>
          </base-material-card>
        </v-tab-item>
      </base-material-tabs>
    </v-col>
    <v-dialog
      v-model="dialog.event.show"
      scrollable
      persistent
    >
      <event-form
        :create="dialog.event.create"
        :view="dialog.event.view"
        :change="dialog.event.change"
        :data="dialog.event.data"
        :show="dialog.event.show"
        @close="dialog.event.show = false, load_events()"
      />
    </v-dialog>
  </v-row>
</template>

<script>
  import moment from 'moment'
  import $ from 'jquery'
  import suggest from '../../../libs/suggestions.min.17.12.0.dev.js'
  import { diff, addedDiff, deletedDiff, updatedDiff, detailedDiff } from 'deep-object-diff'
  import EventForm from './../EventForm'
  export default {
    components: { EventForm },
    props: ['create', 'change', 'view', 'show', 'item'],
    data: () => ({
      selected: {
        type: null,
        item: null,
        current_item: null,
        change_settings: false
      },
      datatable_footer: {
        itemsPerPageText: 'Показывать по',
        pageText: 'из',
        itemsPerPageAllText: 'Все',
      },
      menu: {
        from: false,
        to: false
      },
      event: {
        items: [],
        form: {
          client: '',
        },
      },
      info: {

      },
      loader: {
        show: false,
      },
      dialog: {
        event: {
          show: false,
          item: {},
        },

      },
      events: [

      ],
      search: {
        item: {
          loading: false,
          text: ''
        },
      },
      table: {
        headers: [
          {
            text: '',
            value: 'save',
          },
          {
            text: 'Название',
            value: 'name',
          },
          {
            text: 'Описание',
            value: 'comment',
          },
        ],
      },
      tabs: [
        'Основные',
        'Состав заказа',
      ],
      data: {
        phone: '',
      },
      form: {
        items: []
      },
      logs: [],
      dict: {
        insurer: {},
        phone: {
          1: 'Мобильный',
          2: 'Домашний',
        },
        address: {
          1: 'Юридический адрес',
          2: 'Фактический адрес',
        },
        file: {
          type: {
            0: 'Без типа',
            1: 'Слайдер в описании проекта',
            2: 'Договор поручительства',
            3: 'Документы проекта',
          },
        },
        event: {
          1: 'Звонок',
          2: 'SMS сообщение',
          3: 'Email сообщение',
          4: 'Встреча',
          5: 'Другое',
        },
        type: {
          0: 'Товар',
          1: 'Услуга'
        }
      },
      select: {
        clients: [],
        type: [
        ],
        state: [
          { value: 0, text: 'Новый' },
          { value: 1, text: 'Частично оплачен' },
          { value: 2, text: 'Оплачен' },
          { value: 3, text: 'Отменен' },
        ],
        device: [],
        item: []
      },
      suggestion: {
        address: false
      },
      search: {
        client: {
          loading: false,
          text: ''
        },
        item: {
          loading: false,
          text: ''
        },
      },
    }),
    computed: {
      title: {
        get: function () {
          if (this.create) return 'Создание'
          if (this.change) return 'Изменение'
          if (this.view) return 'Просмотр'
          return ''
        },
      },
    },
    watch: {
      'search.item.text': function () {
        this.load_items(this.search.item.text)
      },
      'search.client.text': function () {
        if (this.search.client.text) { this.load_clients(this.search.client.text) }
      },
      show: function () {
        if (this.show) {
          if (this.change) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }

          if (this.view) {
            this.form = JSON.parse(JSON.stringify(this.item))
          }
          if (this.create) {
            this.form = {

            }
          }
        }
      },
    },
    mounted: function () {
      if (this.create) {
        this.form.created = moment().format('YYYY-MM-DD')
      }
      this.form.client = localStorage.getItem("client") || ''
      if (this.form.client) {
        this.load_clients_id(this.form.client)
      }
      var id = null
      if (this.item && this.item.id) id = this.item.id
      else
        if (this.$route.query.id && (this.view || this.change)) id = this.$route.query.id
      if (id) {
        this.axios.post('/api/order/list', { id: id })
          .then(result => {
            if (!result.data.error) {
              this.form = result.data.data[0]
              if (this.form.created) this.form.created = moment(this.form.created).format('YYYY-MM-DD')
              this.form.items = this.form.items || []
              if (this.form.client) {
                this.load_clients_id(this.form.client)
              }
              this.load_events()
              this.load_logs()
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    },
    methods: {
      delete_item: function (item) {
        if (confirm('Подтвердите удаление')) {
          this.form.items = this.form.items.filter(a => a != item)
        }
      },
      change_item: function (item) {
        this.selected.current_item = item
        this.selected.change_settings = true
        console.log(this.selected.current_item)
      },
      item_selected: function () {
        this.form.items.push(this.selected.item)
        this.selected.item = null
        const item = this.form.items[this.form.items.length - 1]
        for (const x in item.settings) {
          console.log(item.settings[x].key)
          item.attributes[item.settings[x].key] = item.settings[x].default_value
        }
      },
      client_filter: function (item, query, text) {
        if (item.legal && (item.legal.name.full).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.name.short).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.kpp).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.inn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        if (item.legal && (item.legal.ogrn).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      item_filter: function (item, query, text) {
        if (item && (item.name).toUpperCase().indexOf(query.toUpperCase()) > -1) return true
        return false
      },
      load_clients: function (text) {
        this.search.client.loading = true
        this.axios.post('/api/client/list', {
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      load_items: function (text) {
        this.search.item.loading = true
        this.axios.post('/api/item/list', {
          client: this.form.client,
          search: text,
          limit: 10
        })
        .then(result => {
          this.search.item.loading = false
          if (!result.data.error) {
            this.select.item = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.item.loading = false
        })
      },
      load_clients_id: function (id) {
        if (!id) return
        this.axios.post('/api/client/list', {
          id: id
        })
        .then(result => {
          this.search.client.loading = false
          if (!result.data.error) {
            this.select.clients = result.data.data
          }
        })
        .catch(e => {
          console.log(e)
          this.search.client.loading = false
        })
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.form.files.push(response.data.data[x])
                }

                console.log(this.form.files)
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
      settings_change: function (item) {
        console.log(item)
        if (item.new) {
          item.new = false
          this.form.settings.push({
            new: true,
            type: 0,
            values: []
          })
        }
      },
      get_color: function (item, type) {
        return 'white'
      },
      load_events: function () {
        this.axios.post('/api/event/list', {
          order: this.form.id,
        })
          .then(result => {
            if (!result.data.error) {
              for (const x in result.data.data) {
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].color = this.$store.state.dict.events[result.data.data[x].type].color
                result.data.data[x].start = moment(result.data.data[x].date).format('DD.MM.YYYY') + ' ' + String(result.data.data[x].time).substring(0, 5)
                result.data.data[x].end = moment(result.data.data[x].date).format('YYYY-MM-DD') + ' ' + String(result.data.data[x].time).substring(0, 5)
                if (result.data.data[x].type > 0 && this.$store.state.dict.events[result.data.data[x].type]) result.data.data[x].name = this.$store.state.dict.events[result.data.data[x].type].name
              }
              this.events = result.data.data
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      load_logs: function () {
        this.axios.post('/api/log/list', { entity: this.form.id, limit: 5 })
          .then(result => {
            if (!result.data.error) {
              this.logs = result.data.data || []
              for (const x in this.logs) {
                this.logs[x].date_text = moment(this.logs[x].date).format('DD.MM.YYYY HH:mm')
                this.logs[x].diff = (diff(JSON.parse(this.logs[x].old), (JSON.parse(this.logs[x].change))))
              }
            }
          })
          .catch(e => {
            console.log(e)
          })
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract: function (number, date) {
        return number + '/' + moment(date).format('DDMM')
      },
      showEvent: function (event) {
        this.dialog.event.data = event
        this.dialog.event.show = true
        this.dialog.event.create = false
        this.dialog.event.change = true
        this.dialog.event.view = false
      },
      showCreateEvent: function (event) {
        this.dialog.event.data = {
          order: this.form.id,
          order_item: this.form,
        }
        console.log(this.dialog.event.data)
        this.dialog.event.show = true
        this.dialog.event.create = true
        this.dialog.event.change = false
        this.dialog.event.view = false
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      open_file: function (id, item) {
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: id,
            name: 'id',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item,
            name: 'name',
          })
        )
        form.appendTo('body').submit()
      },
      adress_input: function (item) {
        if (!this.suggestion.address) {
          console.log('[name=address]')
          this.suggestion.address = true
          $('[name=address]').suggestions({
            token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
            type: 'ADDRESS',
            count: 5,
            onSelect: data => {
              this.form.address = data.unrestricted_value
              this.form.address_data = data.data
            },
          })
        }
      },
      create_order: function () {
        this.axios.post('/api/order/create', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$emit('list')
              } else {
                this.$store.commit('snackbar', result.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', e || 'Ошибка при сохранении данных')
            })
      },
      save_order: function () {
          this.axios.post('/api/order/save', this.form)
            .then(result => {
              if (!result.data.error) {
                this.$store.commit('snackbar', 'Данные успешно сохранены')
                this.$emit('view', this.form.id)
              } else {
                this.$store.commit('snackbar', result.data.data || 'Ошибка при сохранении данных')
              }
            })
            .catch(e => {
              console.log(e)
              this.$store.commit('snackbar', e || 'Ошибка при сохранении данных')
            })
      },
    },
  }
</script>
